import { Container, cn } from "@lumberset/ui";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { Crumbs } from "../../components/crumbs";

export const Route = createFileRoute("/_app/settings")({ component: SettingsLayout });

const tab = cn(
  "txt-compact-small-plus transition-fg shrink-0 rounded-full px-3 py-1.5 text-ui-fg-subtle outline-none",
  "hover:text-ui-fg-base focus-visible:shadow-borders-focus",
  "aria-[current=page]:bg-ui-bg-base aria-[current=page]:text-ui-fg-base aria-[current=page]:shadow-elevation-card-rest",
);

function SettingsLayout() {
  const { yard } = Route.useRouteContext();
  return (
    <>
      <Crumbs trail={[{ label: "Settings" }]} />
      <Container className="bg-transparent p-0 shadow-none">
        <nav
          className="scrollbar-none flex items-center gap-x-1 overflow-x-auto p-0.5"
          aria-label="Settings"
        >
          <Link to="/settings" activeOptions={{ exact: true }} className={tab}>
            {yard.kind === "builder" ? "Company" : "Yard"}
          </Link>
          <Link to="/settings/standards" className={tab}>
            Estimating standards
          </Link>
          <Link to="/settings/team" className={tab}>
            Team
          </Link>
          <Link to="/settings/billing" className={tab}>
            Billing
          </Link>
        </nav>
      </Container>
      <Outlet />
    </>
  );
}
